export default __webpack_public_path__ + "7afe119d8a1e26706a93b805b2bf6b7f.svg";